import styled from "styled-components";

export const Wrapper = styled.div`
  .ant-input-filled:focus, .ant-input-filled:focus-within {
    outline: 0;
    border-color: var(--app-border);
    background-color: var(--app-surface);
  }

  .dropdown-seller-wrap {
    margin: 15px;
  }

  .dropdown-seller-title {
    margin-bottom: 12px;
    font-weight: 600;
    color: var(--app-text);
  }

  .dropdown-seller-list {
    display: flex;
    flex-direction: column;
    row-gap: 5px;
    max-height: 320px;
    overflow-y: auto;
  }

  .dropdown-seller-item {
    display: flex !important;
    align-items: center !important;
    text-align: left !important;
    padding: 8px !important;
    gap: 5px;
    border-radius: 6px !important;
    border: 0 !important;
    background: transparent !important;
    color: var(--app-text) !important;
    box-shadow: none !important;
  }

  .dropdown-seller-item:hover {
    background: var(--app-surface-alt) !important;
  }

  .dropdown-seller-item.is-current {
    background: color-mix(in srgb, #f45b68 14%, var(--app-surface)) !important;
  }

  .dropdown-seller-avatar {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .dropdown-seller-name {
    font-weight: 500;
    font-size: 12px;
    flex-grow: 1;
    color: var(--app-text);
  }

  .dropdown-seller-name.is-current {
    font-weight: 700;
  }

  .dropdown-seller-delete-btn {
    margin-left: 4px;
    display: flex;
    align-items: center;
  }

  .dropdown-seller-delete-icon {
    font-size: 16px;
  }

  .dropdown-create-account-btn {
    display: flex;
    align-items: center;
  }

  .dropdown-delete-title,
  .dropdown-delete-name {
    color: var(--app-text) !important;
  }

  .dropdown-delete-alert {
    border-color: color-mix(in srgb, #f45b68 35%, var(--app-border)) !important;
    background: color-mix(in srgb, #f45b68 10%, var(--app-surface-alt)) !important;
    color: var(--app-text) !important;
  }
`;